import { logOff } from '../slices/logout/slice';
import { persistor } from '../store';
import { useAppDispatch } from './useAppDispatch';

const useResponseHandler = (mapFunction?: (data: any) => any) => {
  const dispatch = useAppDispatch();

  return async (response: Response) => {
    if (response.status === 401) {
      dispatch(logOff());
      await persistor.purge();
      return;
    }
    if (response.status === 204) {
      return Promise.resolve();
    }
    const data = await response.json();
    if (response.ok) {
      return !!mapFunction ? mapFunction(data) : data;
    } else {
      return Promise.reject(response.status);
    }
  };
};

export default useResponseHandler;
